/**
 * @desc 创建BOM供应链申请外发审核
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<string>;
export function request(
  body: defs.basics.PlmBomOutSupplyApprovalRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/bom/outgoing/supplyApproval`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
